import { createContext } from 'react';

interface AppContextType {
  http: any;
}

const AppContext = createContext<AppContextType>({
  http: null,
});
export default AppContext;
